import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ManageDossier from '../../../components/dossiermanagement/logisticsDossier/logisticsDossier'
import { translate } from 'react-polyglot'
// import { push as navigateTo } from 'react-router-redux'
import TrackingContainer from '../../../containers/tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.auth
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      /* navigateTo */
    }, dispatch)
  }
}

var decoratedComponent = TrackingContainer(ManageDossier, true)
export default connect(mapStateToProps, mapDispatchToProps)(translate()(decoratedComponent))
